import { gql } from "@apollo/client";

export const GET_PERMIT_TYPES_COUNT = gql`
  query GetPermitTypesCount($payeeAccountId: uuid!) {
    permitTypesAggregate: permit_type_aggregate(where: { payee_account_id: { _eq: $payeeAccountId } }) {
      aggregate {
        count
      }
    }
  }
`;

export interface GetPermitTypesCountData {
  permitTypesAggregate: {
    aggregate: {
      count: number;
    };
  };
}

export interface GetPermitTypesCountVars {
  payeeAccountId: string;
}
